import Textarea from "@hudson/ui/components/FormFields/Textarea";
import Field from "@hudson/ui/components/FormFields/Field";

function Address({
  className = "",
  errorMessage,
  fieldName,
  label,
  requiredPlaceholder,
}: {
  className?: string;
  errorMessage: string;
  fieldName: string;
  label: string;
  requiredPlaceholder?: string;
}): JSX.Element | null {
  return (
    <Field
      className={className}
      errorMessage={errorMessage}
      fieldControl={(value, onChange, inError, onBlur) => (
        <Textarea
          autoComplete="billing street-address"
          className="w-80"
          inError={inError}
          onBlur={onBlur}
          onChange={onChange}
          required={Boolean(errorMessage)}
          requiredPlaceholder={requiredPlaceholder}
          value={value ? String(value) : ""}
        />
      )}
      fieldName={fieldName}
      fieldValidations={{ required: errorMessage }}
      label={label}
    />
  );
}

export default Address;
